// src/lib/requestTypeSlugs.js
// URL slug ↔ <el-tabs> internal name for RequestsView (XOL-209 PR 3).
// URL uses friendly plurals; el-tab-pane :name="..." uses verb-singulars.
// Keep these maps in sync with the constrained route pattern in
// src/router/index.js and the regex in src/lib/routerMigration.js.

export const SLUG_TO_INTERNAL = {
  summary: 'report',
  acquire: 'acquire',
  shares: 'share',
  upgrades: 'upgrade',
  backhaul: 'backhaul',
  dismantle: 'dismantle',
  calendar: 'calendar'
}

export const INTERNAL_TO_SLUG = Object.keys(SLUG_TO_INTERNAL)
  .reduce(function (acc, slug) { acc[SLUG_TO_INTERNAL[slug]] = slug; return acc }, {})
